module.exports = __webpack_public_path__ + "static/media/alplogo.caac14d6.jpg";